import type { ClientApplication } from '../../client';
import type { TMDBService } from './tmdb';

export const tmdbPath = 'api/tmdb';

export const tmdbMethods = ['getPosters', 'get'] as const;

export interface GetPostersParams {
  tmdb_id: number;
  is_tv_show: boolean;
}

export interface TmdbFilmLookupResult {
  title: string;
  year: number | string;
  url: string;
  best_available_format: string | null;
  best_video: string | null;
  best_audio: string | null;
  best_english_friendly: string | null;
  /** The write-up behind each pick (the pick fields hold only release names). */
  best_video_notes: string | null;
  best_audio_notes: string | null;
  best_english_friendly_notes: string | null;
  upcoming_release: string | null;
  additional_info: string | null;
  blu_ray_url: string | null;
}

export type TMDBClientService = Pick<TMDBService, (typeof tmdbMethods)[number]>;

export const tmdbClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(tmdbPath, connection.service(tmdbPath), {
    methods: tmdbMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [tmdbPath]: TMDBClientService;
  }
}
